import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//Renders timer in descreasing order.
function Timer({ seconds, onTimerComplete, concatenateText = "" }) {
  let [number, setNumber] = useState(seconds);
  let timer;
  if (number > 0) {
    timer = setInterval(() => {
      setNumber(Math.max(number - 1, 0));
      clearInterval(timer);
    }, 1000);
  } else {
    //Calls callback
    onTimerComplete();
  }

  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div>
      <div style={{marginBottom:"2rem"}}>(00:{number}s)</div>
      {concatenateText}
    </div>
  );
}

Timer.propTypes = {
  seconds: PropTypes.number.isRequired,
  onTimerComplete: PropTypes.func.isRequired,
  concatenateText: PropTypes.string,
};

export default Timer;
